var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"no-decoration white--text text-caption",attrs:{"color":"red","rounded":"","dark":""},on:{"click":_vm.goSignInUI}},[_vm._v(" Google IDでサインイン ")])
}
var staticRenderFns = []

export { render, staticRenderFns }